var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('annualreport.title')))]),_vm._v(" "),_c('loader',{attrs:{"loading":_vm.loading,"error":_vm.error}},[_c('div',{staticClass:"row flex"},_vm._l((_vm.countries),function(country){return _c('div',{staticClass:"flex__item flex--column col-xs-12"},[_c('year-graph-widget',{key:country.id,staticClass:"flex__item",attrs:{"country":country}})],1)}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cb1d0dc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AnnualReportPage.vue
// module id = 853
// module chunks = 1